<template>
  <div class="c-rect-wrapper">
    <c-custom-dnd
      v-for="rect in rect_list"
      :key="rect.rect_id"
      :w="rect.width"
      :h="rect.height"
      :x="rect.left"
      :y="rect.top"
      :z="rect.z_index"
      :rect="rect"
      :minw="rect_options.minw"
      :minh="rect_options.minh"
      :isActive="rect.draggable || rect.resizable"
      :isTop="rect_max_index === rect.z_index"
      @rectActivate="rectActivate"
      @rectDeactivate="rectDeactivate"
      @rectResize="rectResize"
      @rectPosition="rectPosition"
    >
      <template v-slot:map>
        <c-rect-item
          :rect_id="rect.rect_id"
        >
        <!-- :active="addActiveBlockClass(rect.rect_id)" -->
        <template #main="{ props_slot }">
          <c-rect-item-header
            :rect="rect"
            :disabled_add_route="countRoutesByRect(rect.rect_id) >= 3"
            :is_loading="false"
            @rectRemove="openConfirmModal(rect, 'rect')"
            @routeAdd="openModalRoutesAdd"
            @rectActivate="rectActivate"
          >
            <template #col-center>
              <c-routes-list
                :rect_id="rect.rect_id"
                :cars_list="props_slot.cars_list"
                :is_loading="props_slot.cars_loading"
                @removeRoute="openConfirmModal($event, 'route')"
                @rectActivate="rectActivate(rect)"
              />
            </template>
          </c-rect-item-header>

          <c-rect-item-content>
            <!-- :active="addActiveBlockClass(rect.rect_id)" -->
            <c-map :ref="`map-${rect.rect_id}`"
              :rect_id="rect.rect_id"
              :routes_list="props_slot.routes_list"
              :cars_list="props_slot.cars_list"
            />
          </c-rect-item-content>

        </template>
      </c-rect-item>
      </template>
    </c-custom-dnd>

    <c-add-routes
      ref="c-add-routes"
      :rect_id="rect_id"
      :count_routes="countRoutesByRect(rect_id)"
      @returnRoute="routeAdd"
    />

    <c-confirm-modal
      ref="c-confirm-modal"
      :uuid="modal.uuid"
      :item="modal.item"
      :message="modal.message"
      @handleOk="handleOk"
      @handleClose="handleClose"
    />

  </div>
</template>

<script>
import cRectItem from '@/components/rect/c-rect-item'
import cRectItemHeader from '@/components/rect/c-rect-item-header'
import cRectItemContent from '@/components/rect/c-rect-item-content'
import cRoutesList from '@/components/routes/c-routes-list'
import cMap from '@/components/map/c-map'
import cAddRoutes from '@/components/routes/c-add-routes'
import cConfirmModal from '@/components/base/c-confirm-modal'
import cCustomDnd from '@/components/base/c-custom-dnd.vue'

import { getMaxValueOfArray } from '@/helpers/base'
export default {
  name: 'c-rect-wrapper',
  components: {
    cRectItem,
    cRectItemHeader,
    cRectItemContent,
    cRoutesList,
    cMap,
    cAddRoutes,
    cConfirmModal,
    cCustomDnd
  },
  data() {
    return {
      rect_id: null,
      rect_active: {},
      modal: {
        message: '',
        item: {},
        uuid: null
      }
    }
  },
  created() {
    this.rectKeyupEscapeDeactivate()
  },
  computed: {
    rect_list() {
      return this.$store.getters.RECT_LIST
    },
    rect_options() {
      return this.$store.getters.RECT_OPTIONS
    },
    rect_max_index() {
      return Math.max(...this.$store.getters.RECT_LIST.map(({ z_index }) => z_index))
    },
  },
  methods: {
    /* Хэлперы */
    updateZIndex() {
      let index_list = this.rect_list.map(i => i.z_index)
      let max_index = getMaxValueOfArray(index_list)
      return max_index + 1
    },
    addActiveBlockClass(rect_id) {
      return rect_id == this.rect_active.rect_id
    },
    countRoutesByRect(rect_id) {
      return this.$store.getters.RECT_ROUTES_BY_RECT_ID(rect_id).length
    },
    /* Хэлперы */

    /* Взаимодействие с vuex */
    rectUpdate(obj) {
      this.$store.commit('RECT_UPDATE', obj)
    },
    rectRemove(rect_id) {
      this.$store.commit('RECT_REMOVE', rect_id)
    },
    routeAddByRect(obj, rect_id) {
      this.$store.commit('RECT_ROUTES_ADD', {
        rect_id,
        ...obj,
      })
      let rect_obj = this.$store.getters.RECT_BY_ID(rect_id)
      rect_obj.center = this.routeCenter(obj)
      this.rectUpdate(rect_obj)
    },
    routeRemoveByRect(route_and_type, rect_id) {
      this.$store.commit('RECT_ROUTES_REMOVE', { route_and_type, rect_id })
    },
    /* Взаимодействие с vuex END */

    /* vue-drag-resize */
    rectActivate(rect) {
      this.rectDeactivate()

      let obj = { ...rect }
      obj.draggable = true
      obj.resizable = true
      obj.z_index = this.updateZIndex()
      this.rectUpdate(obj)
      this.rect_active = { ...obj }
    },
    rectDeactivate() {
      if(Object.keys(this.rect_active).length !== 0) {
        this.$refs[`map-${this.rect_active.rect_id}`][0].resizeMap()

        let obj = { ...this.rect_active }
        obj.draggable = false
        obj.resizable = false
        this.rectUpdate(obj)
        this.rect_active = {}
      }
    },
    rectResize({ width, height, left, top }, rect) {
      let obj = { ...rect }
      obj.width = width || rect.width
      obj.height = height || rect.height
      obj.left = left || rect.left
      obj.top = top || rect.top

      this.rect_active = { ...obj }
    },
    rectPosition({ left, top }, rect) {
      let obj = { ...rect }
      obj.left = left
      obj.top = top
      this.rect_active = { ...obj }
    },
    rectResizeStop(ref) {
      this.rectUpdate(this.rect_active)
      this.$refs[ref][0].resizeMap()
    },
    rectPositionStop(ref) {
      this.rectUpdate(this.rect_active)
      this.$refs[ref][0].resizeMap()
    },
    rectKeyupEscapeDeactivate() {
      document.onkeyup = e => {
        e = e || window.event
        if (e.code == 'Escape') {
          this.rectDeactivate()
        }
      }
    },
    /* vue-drag-resize END */

    /* Маршруты */
    openModalRoutesAdd(rect_id) {
      this.rect_id = rect_id

      this.$nextTick(() => {
        this.$refs['c-add-routes'].openModal()
      });
    },
    routeAdd(obj) {
      this.routeAddByRect(obj, this.rect_id)
      this.rect_id = null
    },
    routeRemove(obj) {
      let { route_and_type, rect_id } = obj
      this.routeRemoveByRect(route_and_type, rect_id)
    },
    routeCenter(obj) {
      try {
        let obj_full = this.$store.getters.ROUTE_BY_ID(obj.dtransport_id)

        let arr = obj_full.geozone.geopoints.forward

        let twoTimesSignedArea = 0;
        let cxTimes6SignedArea = 0;
        let cyTimes6SignedArea = 0;

        let length = arr.length

        let x = function (i) {
          return arr[i % length].lat
        };
        let y = function (i) {
          return arr[i % length].lng
        };

        for (let i = 0; i < arr.length; i++) {
          let twoSA = x(i) * y(i + 1) - x(i + 1) * y(i);
          twoTimesSignedArea += twoSA;
          cxTimes6SignedArea += (x(i) + x(i + 1)) * twoSA;
          cyTimes6SignedArea += (y(i) + y(i + 1)) * twoSA;
        }
        let sixSignedArea = 3 * twoTimesSignedArea;
        return {lat: cxTimes6SignedArea / sixSignedArea, lng: cyTimes6SignedArea / sixSignedArea};
      } catch (error) {
        console.log(error)
        return undefined
      }
    },
    /* Маршруты END */

    /* Модальное окно */
    openConfirmModal(item, uuid) {
      this.modal.item = { ...item }
      this.modal.uuid = uuid

      if(uuid == 'rect') {
        this.modal.message = 'Ви впевнені, що хочете видалити цю карту?'
      }
      if(uuid == 'route') {
        this.modal.message = 'Ви впевнені, що хочете видалити цей маршрут?'
      }

      this.$refs['c-confirm-modal'].openModal()
    },
    handleOk({ item, uuid }) {
      if(uuid == 'rect') {
        this.rectRemove(item.rect_id)
      }
      if(uuid == 'route') {
        this.routeRemove(item)
      }
    },
    handleClose() {
      this.modal = {
        message: '',
        item: {},
        uuid: null
      }
    },
    /* Модальное окно END */
  }
}
</script>

<style lang="scss">
  .c-rect-item {
    border-radius: 0;
  }
  .c-rect-item__header {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .c-rect-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: calc(100vh - 25px);
    z-index: 1;

    .c-map {
      width: 100% !important;
      height: 100% !important;
    }

    .vdr {
      &.active{
        &:before {
          border-radius: 12px;
        }
      }
    }
    .vdr-stick {
      z-index: 3;
    }
  }
</style>